import React from "react";
import {Icon} from "@assecobs/react-common-components/index";
import {I18nMessage} from "assecobs-faktor-web-common/index";
import {injectIntl} from "react-intl";

export default injectIntl(({labelKey, titleKey, onClick, intl}) => (
    <button type="button"
            className="btn btn-lg btn-type-d abs-btn-icon authentication-btn__cancel"
            onClick={onClick}
            title={intl.formatMessage({id: titleKey})}>
        <Icon name="abs_arrow_back" className="abs-btn-icon_icon"/>
        <I18nMessage id={labelKey} className="abs-btn-icon_title"/>
    </button>
));
